import * as React from 'react'

function SvgFunSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M10.562 16.237a5.646 5.646 0 01-4.019-1.666 5.64 5.64 0 01-1.663-4.014 5.64 5.64 0 011.662-4.013 5.653 5.653 0 014.02-1.663 5.64 5.64 0 014.014 1.662 5.639 5.639 0 011.662 4.014 5.64 5.64 0 01-1.663 4.015 5.634 5.634 0 01-4.013 1.665m10.162 3.153l-4.196-4.196a7.496 7.496 0 001.59-4.637 7.507 7.507 0 00-2.213-5.344A7.507 7.507 0 0010.561 3a7.52 7.52 0 00-5.348 2.213A7.505 7.505 0 003 10.557c0 2.019.786 3.917 2.214 5.344a7.515 7.515 0 005.348 2.217 7.49 7.49 0 004.637-1.594l4.196 4.196a.937.937 0 001.33 0 .94.94 0 000-1.33" />
    </svg>
  )
}

export default SvgFunSearch
